import React from "react";
import { Input, Select } from "antd";
import {
  genderCondition,
  formStatus,
  orderStatus,
  orderType,
  EngagementTag,
  hairLossStages,
} from "modules/utilities/utility";

function TextFields({
  placeHolder,
  value,
  setValue,
  type,
  minDate,
  condition,
  isDisabled,
}) {
  if (condition) {
    switch (condition) {
      case "gender":
        return (
          <Select
            placeholder="Select value"
            options={genderCondition}
            value={value}
            style={{ width: "100%" }}
            onChange={(role) => {
              setValue(role);
            }}
          />
        );
      case "form status":
        return (
          <Select
            placeholder={placeHolder}
            options={formStatus}
            style={{ width: "100%" }}
            value={value}
            onChange={(role, event) => {
              setValue(role);
            }}
          />
        );
      case "order status":
        return (
          <Select
            placeholder={placeHolder}
            options={orderStatus}
            style={{ width: "100%" }}
            value={value}
            onChange={(role) => {
              setValue(role);
            }}
          />
        );
      case "order type":
        return (
          <Select
            placeholder={placeHolder}
            options={orderType}
            style={{ width: "100%" }}
            value={value}
            onChange={(role) => {
              setValue(role);
            }}
          />
        );
      case "engagement tag":
        return (
          <Select
            placeholder={placeHolder}
            options={EngagementTag}
            style={{ width: "100%" }}
            value={value}
            onChange={(role) => {
              setValue(role);
            }}
          />
        );
      case "hair loss stages":
        return (
          <Select
            placeholder={placeHolder}
            options={hairLossStages}
            style={{ width: "100%" }}
            value={value}
            onChange={(role) => {
              setValue(role);
            }}
          />
        );
      default:
    }
  }

  if (type === "date") {
    return (
      <input
        type="date"
        onChange={(event) => setValue(event.target.value)}
        min={minDate}
        value={value}
        max="9999-12-31"
        onKeyDown={(event) => event.preventDefault()}
        style={{
          width: "100%",
          height: "33px",
          borderWidth: "1px",
          outline: "none",
          paddingLeft: "12px",
          fontFamily: "Manrope",
          fontStyle: "normal",
          fontSize: "15px",
          alignContent: "center",
        }}
      />
    );
  }

  return (
    <Input
      onChange={(event) => setValue(event.target.value)}
      placeholder={placeHolder}
      inputProps={{ "aria-label": `${placeHolder}`, color: "#fff" }}
      value={value}
      fullWidth
      variant="standard"
      disabled={isDisabled}
      type={type}
      InputProps={{
        disableUnderline: true,
      }}
    />
  );
}

export default TextFields;
